import { Card } from "antd";
import { useTranslation } from "react-i18next";

export default function CustomerCard() {
    const { t } = useTranslation();
    const data = {
        old: {
            value: 8,
            revenue: 2400000,
            color: "#3b82f6",
        },
        new: {
            value: 16,
            revenue: 3600000,
            color: "#14b8a6",
        },
    };

    const totalCustomer = data.old.value + data.new.value;
    const totalRevenue = data.old.revenue + data.new.revenue;

    const format = (num: number) =>
        num.toLocaleString("vi-VN") + " đ";

    return (
        <Card
            title={t('customer_report.customer')}
        >
            {/* TOP */}
            <div className="flex justify-between">
                <div>
                    <div className="text-gray-500 dark:text-gray-400 text-sm">
                        {t('customer_report.quantity')}
                    </div>
                    <div className="text-xl font-bold text-black dark:text-white">
                        {totalCustomer}
                    </div>
                </div>
                <div>
                    <div className="text-gray-500 dark:text-gray-400 text-sm">
                        {t('customer_report.spending')}
                    </div>
                    <div className="text-xl font-bold text-black dark:text-white">
                        {format(totalRevenue)}
                    </div>
                </div>
            </div>

            {/* PROGRESS SỐ LƯỢNG */}
            <div className="mt-4 flex items-center gap-3">
                <div className="w-24 text-sm text-gray-600 dark:text-gray-300">
                    {t('customer_report.quantity')}
                </div>

                <div className="flex-1 h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden flex">
                    {Object.values(data).map((item, i) => {
                        const percent = (item.value / totalCustomer) * 100;

                        return (
                            <div
                                key={i}
                                style={{
                                    width: `${percent}%`,
                                    background: item.color,
                                }}
                            />
                        );
                    })}
                </div>
            </div>

            {/* PROGRESS CHI TIÊU */}
            <div className="mt-3 flex items-center gap-3">
                <div className="w-24 text-sm text-gray-600 dark:text-gray-300">
                    {t('customer_report.spending')}
                </div>

                <div className="flex-1 h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden flex">
                    {Object.values(data).map((item, i) => {
                        const percent = (item.revenue / totalRevenue) * 100;

                        return (
                            <div
                                key={i}
                                style={{
                                    width: `${percent}%`,
                                    background: item.color,
                                }}
                            />
                        );
                    })}
                </div>
            </div>

            {/* TABLE HEADER */}
            <div className="grid grid-cols-3 text-sm mt-4 font-medium text-gray-500 dark:text-gray-400">
                <div>{t('customer_report.customer')}</div>
                <div>{t('customer_report.quantity')}</div>
                <div className="text-right">{t('customer_report.spending')}</div>
            </div>

            {/* KH CŨ */}
            <div className="grid grid-cols-3 text-sm mt-2 items-center text-gray-800 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 px-1 py-1 rounded">
                <div className="flex items-center gap-2">
                    <span
                        className="w-3 h-3 rounded-full"
                        style={{ background: data.old.color }}
                    />
                    {t('customer_report.old_customer')}
                </div>
                <div>{data.old.value}</div>
                <div className="text-right">{format(data.old.revenue)}</div>
            </div>

            {/* KH MỚI */}
            <div className="grid grid-cols-3 text-sm mt-2 items-center text-gray-800 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 px-1 py-1 rounded">
                <div className="flex items-center gap-2">
                    <span
                        className="w-3 h-3 rounded-full"
                        style={{ background: data.new.color }}
                    />
                    {t('customer_report.new_customer')}
                </div>
                <div>{data.new.value}</div>
                <div className="text-right">{format(data.new.revenue)}</div>
            </div>
        </Card>
    );
}